import { PermissionTemplate } from "../../setting/models/permission-template.model";

export class AppsModel {
  id: number = 0;
  name: string = '';
  description: string = '';
  canShowOnWebsite: boolean = false;
  type: number = 1;
  companyId: number = 0;
  appIcon: string = '';
  licenses: Array<LicensesModel> = [];
  items: Array<LicensesModel> = [];
  plansList: Array<PlansOverview> = [];
  isAppSelect: boolean = false;
  status: number = 0;
  appsIcons: string[] = [];
  subscriptionCount: number = 0;
}

export class LicensesModel {
  id: number = 0;
  licenseId: number = 0;
  monthlyPrice: number = 0;
  appId: number = 0;
  orderId: number = 0;
  fieldName: string = '';
  licenseType: number = 0;
  featureDescription: string = '';
  permissionTemplate: PermissionTemplate = new PermissionTemplate();
  licenseAttributes: Array<LicenseAttributesModel> = [];
}

export class LicenseAttributesModel {
  id: number = 0;
  licenseId: number = 0;
  licenseAttributeType: number = 0;
  licenseAttributeId: number = 0;
  label: string = '';
  order: number = 0;
  defaultValue: any;
  isEditPrice: boolean = false;
  dataType: string = '';
  isVisibleOnDefaultPriceSetup: boolean = false;
  isVisibleOnSubscriptionPlan: boolean = false;
  isEditableOnSubscriptionPlan: boolean = false;
  isVisibleOnSubscription: boolean = false;
  isEditableOnSubscription: boolean = false;
}

export class PlansOverview {
  monthlyCostLabel: string = '';
  monthlyCost: number = 0;
  yearlyCostLabel: string = '';
  yearlyCost: number = 0;
  isDiscount: boolean = false;
  discountVal: any;
  discountType: number = 1;
  discountCrudVal: string = 'apply';
}
